import { gql } from '@apollo/client';

const SECURITY_STATUS_FIELDS = gql`
  fragment SecurityStatusFields on AccountSecurityStatus {
    checkedAt
    hasPassword
    hasTotp
    hasPasskey
    recoveryCodesConfigured
    recoveryCodesRemainingCount
    totpDevices {
      credentialId
      type
      label
      createdAt
      lastUsedAt
      transports
    }
    passkeys {
      credentialId
      type
      label
      createdAt
      lastUsedAt
      transports
    }
    recoveryCodeCredentials {
      credentialId
      type
      label
      createdAt
      lastUsedAt
      transports
    }
  }
`;

const SECURITY_EVENT_FIELDS = gql`
  fragment SecurityEventFields on SecurityEvent {
    securityEventId
    userId
    actorUserId
    source
    eventType
    category
    severity
    result
    sessionId
    clientId
    targetResourceType
    targetResourceId
    credentialId
    credentialLabel
    ipAddress
    userAgent
    metadata
    occurredAt
    createdAt
  }
`;

export const SECURITY_STATUS_GET_CURRENT_USER = gql`
  ${SECURITY_STATUS_FIELDS}
  query SecurityStatusGetCurrentUser {
    securityStatusGetCurrentUser {
      ...SecurityStatusFields
    }
  }
`;

export const SECURITY_STATUS_GET_BY_USER_ID = gql`
  ${SECURITY_STATUS_FIELDS}
  query SecurityStatusGetByUserId($userId: ID!) {
    securityStatusGetByUserId(userId: $userId) {
      ...SecurityStatusFields
    }
  }
`;

export const SECURITY_EVENTS_GET_CURRENT_USER = gql`
  ${SECURITY_EVENT_FIELDS}
  query SecurityEventsGetCurrentUser($limit: Int) {
    securityEventsGetCurrentUser(limit: $limit) {
      ...SecurityEventFields
    }
  }
`;

export const SECURITY_EVENTS_GET_BY_USER_ID = gql`
  ${SECURITY_EVENT_FIELDS}
  query SecurityEventsGetByUserId($userId: ID!, $limit: Int) {
    securityEventsGetByUserId(userId: $userId, limit: $limit) {
      ...SecurityEventFields
    }
  }
`;

export const SECURITY_SEND_CURRENT_USER_PASSWORD_RESET_EMAIL = gql`
  mutation SecuritySendCurrentUserPasswordResetEmail {
    securitySendCurrentUserPasswordResetEmail {
      success
    }
  }
`;

export const SECURITY_REMOVE_CURRENT_USER_CREDENTIAL = gql`
  mutation SecurityRemoveCurrentUserCredential($credentialId: ID!, $sensitiveActionConfirmationToken: String) {
    securityRemoveCurrentUserCredential(credentialId: $credentialId, sensitiveActionConfirmationToken: $sensitiveActionConfirmationToken) {
      success
    }
  }
`;
